import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import BranchGateway from '~apis/branch';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetBranchListing(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('branch/branchGetBranchListingAttempt', handleGetBranchListing, api);
}

function* handleGetBranchListing(api: BranchGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index } = reduxState.branch.branchListing;
    const { regionName } = reduxState.branch.branchListing.filters;
    const regions = reduxState.branch.allRegions;

    const regionId = regions.find(region => region.regionName === regionName)?.regionId;

    if (!index && index !== 0) {
        yield put(combinedActions.branchGetBranchListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.getBranchListing], {
        authToken,
        index,
        regionId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.branchGetBranchListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.branchGetBranchListingSuccess(response.data));
    }
}
